import { usePickslipStore } from "../stores/pickslipStore";

export const usePickemsNotificationCount = (): number => {
  return usePickslipStore((s) => s.picks?.length ?? 0);
};
